import { redirectToVideo } from '@/utils/redirect'

export function SqueezePage() {
  const handleGetStarted = () => {
    redirectToVideo('i2v')
  }

  return (
    <div className="h-dvh overflow-y-auto bg-black text-white">
      {/* Hero Upload Section */}
      <div className="relative min-h-screen flex items-center justify-center px-4 py-12">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-900 opacity-50" />

        <div className="relative z-10 max-w-7xl mx-auto">
          {/* Badge */}
          <div className="text-center lg:text-left mb-8">
            <div className="inline-flex items-center gap-2 bg-white/5 border border-white/20 rounded-full px-4 py-2">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
              </span>
              <span className="text-white text-sm font-semibold">
                No Limits. No Rules. No Filter.
              </span>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            {/* Left Side - Upload Section */}
            <div className="flex-1 text-center lg:text-left space-y-8">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight">
                Create Any Video.
                <br />
                Make It <span className="text-white">Move</span> 🌶️
              </h1>

              <p className="text-xl md:text-2xl text-gray-300">
                Turn any idea into a naughty AI video in 60 seconds
              </p>

              {/* CTA Button */}
              <div>
                <button
                  onClick={handleGetStarted}
                  className="group relative inline-flex items-center gap-3 bg-white hover:bg-gray-200 text-black text-xl md:text-2xl font-bold px-10 py-5 md:px-12 md:py-6 rounded-full transition-all duration-300 shadow-[0_0_30px_rgba(255,255,255,0.3)] hover:shadow-[0_0_50px_rgba(255,255,255,0.5)] hover:scale-105"
                >
                  Get Started Free
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2.5}
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Right Side - Example Videos */}
            <div className="flex items-start justify-center gap-6 lg:gap-8">
              {/* Video 1 with Before Image */}
              <div className="flex flex-col items-center gap-3">
                <img
                  src="https://funnyclips-content.s3.us-east-1.amazonaws.com/bgus-3397110-001-68fe6a70d468c.jpg"
                  alt="Before"
                  className="w-32 h-32 sm:w-40 sm:h-40 object-cover rounded-lg border-[3px] border-white shadow-lg"
                />

                {/* Arrow */}
                <svg
                  className="w-12 h-16 sm:w-16 sm:h-20 text-white"
                  viewBox="0 0 100 120"
                  fill="none"
                  style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))' }}
                >
                  <path
                    d="M 50 5 Q 48 30, 52 50 Q 48 70, 50 90 L 50 100"
                    stroke="currentColor"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M 50 100 L 35 85 M 50 100 L 65 85"
                    stroke="currentColor"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <div className="border-[6px] border-white rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(255,255,255,0.3)]">
                  <video
                    src="https://funnyclips-content.s3.us-east-1.amazonaws.com/1117(2).mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="w-32 sm:w-40 lg:w-52 object-cover"
                    style={{ aspectRatio: '9/16' }}
                  />
                </div>
              </div>

              {/* Video 2 with Before Image */}
              <div className="flex flex-col items-center gap-3">
                <img
                  src="https://funnyclips-content.s3.us-east-1.amazonaws.com/2f36a780-e605-11ee-aff7-6b8f50f3ed3b.jpg"
                  alt="Before"
                  className="w-32 h-32 sm:w-40 sm:h-40 object-cover rounded-lg border-[3px] border-white shadow-lg"
                />

                {/* Arrow */}
                <svg
                  className="w-12 h-16 sm:w-16 sm:h-20 text-white"
                  viewBox="0 0 100 120"
                  fill="none"
                  style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))' }}
                >
                  <path
                    d="M 50 5 Q 52 30, 48 50 Q 52 70, 50 90 L 50 100"
                    stroke="currentColor"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M 50 100 L 35 85 M 50 100 L 65 85"
                    stroke="currentColor"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <div className="border-[6px] border-white rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(255,255,255,0.3)]">
                  <video
                    src="https://funnyclips-content.s3.us-east-1.amazonaws.com/1117(1).mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="w-32 sm:w-40 lg:w-52 object-cover"
                    style={{ aspectRatio: '9/16' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Section */}
      <div className="relative px-4 py-16 bg-black">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center space-y-3">
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white">Lightning Fast</h3>
              <p className="text-gray-400">
                Your video is ready in 60 seconds or less
              </p>
            </div>

            <div className="text-center space-y-3">
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white">100% Private</h3>
              <p className="text-gray-400">
                Your images and videos are never shared
              </p>
            </div>

            <div className="text-center space-y-3">
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mx-auto">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-white">No Censorship</h3>
              <p className="text-gray-400">Create exactly what you imagine</p>
            </div>
          </div>
        </div>
      </div>

      {/* Example Showcase */}
      <div className="relative px-4 py-16 bg-gradient-to-b from-black via-gray-900 to-black">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
              See What Others Created
            </h2>
            <p className="text-gray-400 text-lg">
              Real examples from real creators
            </p>
          </div>

          {/* Video Row */}
          <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory mb-8">
            <div className="group relative flex-shrink-0 w-48 md:w-56 aspect-[3/4] rounded-xl overflow-hidden border border-white/20 hover:border-white/40 transition-all duration-300 snap-start">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example14.mp4"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>

            <div className="group relative flex-shrink-0 w-48 md:w-56 aspect-[3/4] rounded-xl overflow-hidden border border-white/20 hover:border-white/40 transition-all duration-300 snap-start">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example15.mp4"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>

            <div className="group relative flex-shrink-0 w-48 md:w-56 aspect-[3/4] rounded-xl overflow-hidden border border-white/20 hover:border-white/40 transition-all duration-300 snap-start">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example_4.mp4"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>

            <div className="group relative flex-shrink-0 w-48 md:w-56 aspect-[3/4] rounded-xl overflow-hidden border border-white/20 hover:border-white/40 transition-all duration-300 snap-start">
              <video
                src="https://funnyclips-content.s3.us-east-1.amazonaws.com/example_8.mp4"
                loop
                muted
                playsInline
                autoPlay
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>

      {/* Final CTA */}
      <div className="relative px-4 py-20 bg-black">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="text-4xl md:text-5xl font-black text-white">
            Ready to Create?
          </h2>
          <p className="text-xl text-gray-300">
            Your naughty AI video is just one click away
          </p>

          <button
            onClick={handleGetStarted}
            className="inline-flex items-center gap-3 bg-white hover:bg-gray-200 text-black text-xl font-bold px-10 py-4 rounded-full transition-all duration-300 shadow-[0_0_30px_rgba(255,255,255,0.3)] hover:shadow-[0_0_50px_rgba(255,255,255,0.5)] hover:scale-105"
          >
            Get Started Free
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="relative px-4 py-8 bg-black border-t border-white/10">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gray-500 text-sm leading-relaxed">
            The "No Filter" mode is designed for creative and entertainment
            purposes. Users are responsible for ensuring their content complies
            with platform guidelines and applicable laws. PixelMaker does not
            endorse or take responsibility for user-generated content.
          </p>
        </div>
      </div>
    </div>
  )
}
